<template>
  <div class="pardata_box">
    <div class="req_box">
      <p><b>救援请求</b></p>
      <div class="box_req">
        <ul>
          <li>
            <div class="rescue_box">
              <div class="box" v-for="(v,ind) in obj" :key="ind">
                <p style="line-height: 30px;font-size: 14px;" v-if="v.dict.parentId===0"><b>{{v.dict.name}}服务清单</b></p>
              </div>
              <div class="box">
                <fuwuqingdan :attaArr=obj.slice(1,obj.length)></fuwuqingdan>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <p><b>江泰指挥中心救援整体说明</b></p>
      <div class="box_exp">
        <p><span class="res_box_exp">说明：{{setTxt(stateText,'zh')}}</span></p>
        <attaList :attaArr="acc_list"></attaList>
      </div>
      <p><b>添加整体说明</b></p>
      <div class="com_exp">
        <!-- <textarea name="exp" id="exp" cols="30" rows="10" v-model="exp"></textarea> -->
        <changeLanguage id="exp" v-model='exp'></changeLanguage>
        <ul class="addfujian">
          <li>
            <a class="delete" @click="upacc=true">添加附件</a>
          </li>
          <li v-for="(item,index) in up_acc" v-if="index>0">
            <span>{{item.description || 'no name'}}</span> <a class="delete" @click="up_acc.splice(index,1)">[删除]</a>
          </li>
        </ul>
      </div>
      <div class="upbtn_box">
        <el-button type="primary" @click="apply">通过救援请求</el-button>
      </div>
    </div>
    <el-dialog title="上传附件" :visible.sync="upacc" class="img_dialog" width="50%" center>
      <p><span>附件名称</span>
        <el-input type="text" placeholder="上传方案及报价" v-model="txts"></el-input>
      </p>
      <p>
        <span>
          附件地址
        </span>
        <input type="file" name="file" id="filebox" @change="handleGetFile($event)">
      </p>
      <p class="p">
        <el-button center type="button" size="small" @click="uploadFile(),upacc=false">确定</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
  import qs from "qs";
  import constants from '@/util/constants.js';
  import fuwuqingdan from "@/components/attachment/qingdan1";
  import attaList from "@/components/attachment/index1";
  import changeLanguage from '@/components/common/changeLange.vue'
  export default {
    data() {
      let that = this;
      return {
        file: null,
        upacc: false,
        exp: "",
        token:JSON.parse(window.localStorage.getItem("data")).data,
        obj: [],
        txts: "",
        objdata: {
          add: "出险地:",
          type: "事故类型：风险灾害 ",
          part: "受伤部位：腿部 ",
          weather: "天气灾害：气象灾害 "
        },
        acc_list: [],
        up_acc: [{
          icon: "../../../static/images/eles_no.png",
          description: ""
        }],
        checkList: [],
        def: "",
        bid: [],
        inf: null,
        url: "",
        caseid: this.$route.query.caseid,
        stateText: "",
        codePhoto:'',
        sendText:'发送验证码',
        timer:null,
        sendBtn:false
      };
    },
    components: {
      fuwuqingdan,
      attaList,
      changeLanguage
    },
    destroyed(){
      clearInterval(this.timer)
    },
    methods: {
      setTxt(str, status) {
        if (constants.setTxt(str, status)) {
          return constants.setTxt(str, status)
        } else {
          return str
        }

      },
      apply() {
        let that = this;
        let tUploadCnts = this.up_acc.slice();
        tUploadCnts.shift();
        this.axios
          .post(
            constants.domain + "rescue/bidding/author_rescue",
            qs.stringify({
              token: this.token, //token值
              caseId: this.caseid, //caseid
              stateText2: this.exp, //说明
              upaccStr: JSON.stringify(tUploadCnts),
              checkCode:this.codePhoto
            })
          )
          .then(res => {
            if (res.data.code === 0) {
              that.$router.push({
                path: "/regulator/caseindex/resstep",
                name: "Regresstep",
                params: {
                  token: this.token
                  // obj: this.inf,
                  // data: this.obj
                },
                query: {
                  typeId: this.$route.query.typeId,
                  caseid: that.$route.query.caseid
                }
              });

            }
          });
      },

      loadauxfiles() {
        let that = this;
        fetch(constants.domain + "rescue/case/upload_cnts", {
            method: "POST",
            body: `token=${that.token}&objId=${this.$route.query.caseid}&caseId=${this.$route.query.caseid}&objType=1`,
            mode: "cors",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(function(res) {
            //console.log(res);
            return res.json();
          })
          .then(function(data) {
            data.obj.map(v => {
              if (constants.isPic(v.url)) {
                v.icon = v.url;
              } else {
                v.icon = "../../../static/images/eles_icon.png";
              }
              that.acc_list.push(v);
            });
          });
      },
      up() {
        console.log(this.url);
        let flag = constants.isPic(this.url);

        if (flag) {
          this.up_acc.push({
            url: this.url,
            description: this.txts,
            icon: this.url,
          });
        } else if (!flag) {
          if (this.url == "") {
            this.$message.error("请上传附件");
          } else {
            this.up_acc.push({
              url: this.url,
              description: this.txts,
              icon: "../../../static/images/eles_icon.png"
            });
          }
        }
      },
      handleGetFile(e) {
        this.file = e.target.files[0];
        this.txts = this.file.name;
      },
      uploadFile() {
        let that = this;
        var reader = new FileReader();
        reader.readAsDataURL(this.file);
        let formdata = new FormData();
        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        formdata.append(
          "token",
          this.$route.params.token ||
          JSON.parse(window.localStorage.getItem("data")).data
        );
        reader.onload = function(e) {
          that.avatar = this.result;
          formdata.append("file", that.file);
          that.axios
            .post(
              constants.domain + "rescue/case/upload_file",
              formdata,
              config
            )
            .then(res => {
              that.url = res.data.obj;
              that.up();
            });
        };
      }
    },
    mounted() {
      let that = this;
      fetch(constants.domain + "rescue/case/detail_case", {
          method: "POST",
          body: `token=${this.token}&caseId=${this.caseid}`,
          mode: "cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          that.stateText = data.obj.obj.stateText;
          console.log("reg parinf stateText : " + that.stateText);
          that.obj = data.obj2;
          let addr = "";
          if (data.obj.generalLocation) {
            addr = data.obj.generalLocation.addr || "";
          }
          that.objdata = {
            add: "出险地:" +
              (data.obj.caseCountry || "") +
              (data.obj.caseCity || "") +
              addr,
            type: "事故类型：" + (data.obj.obj.accidentType || ""),
            part: "受伤部位：" + (data.obj.victimList[0].obj.injuredPart || ""),
            weather: "天气灾害：" + (data.obj.obj.weatherTag || "无")
          };
          that.def = data.obj.obj.incidentDesc;
        })
      this.loadauxfiles();
    }
  };
</script>

<style scoped>
  @import url(../../css/parinf.css);

  .data_wrap {
    margin-top: 20px;
    margin-left: 35px;
  }

  .req_box {
    margin-left: 35px;
  }

  .res_box_exp {
    margin-left: 40px;
  }

  .addfujian {
    overflow: hidden;
    margin-left: 35px;
    margin-top: 10px;
  }

  .addfujian li {
    background: url('../../../static/images/fj.png') no-repeat left center;
    padding-left: 20px;
    cursor: pointer;
    margin-bottom: 10px;
    line-height: 30px;
    margin-right: 150px;
    float: left;

  }

  .addfujian li span {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/regulator/Parinf.vue